import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Header } from "../../../components/header";
import { Loading } from "../../../components/loading";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { useCategory } from "../hooks";
import { CustomersList } from "../../customers/components";

type ICategoryParams = {
  id: string;
};

export const Category: React.FC = () => {
  const { id } = useParams<ICategoryParams>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate("/");
    }
  }, []);

  const { data, loading } = useCategory(+id!);

  if (loading) return <Loading />;

  const category = data?.category?.result;

  return (
    <>
      <Header
        title="Catégorie"
        subtitle={category?.name}
        buttons={[
          {
            actionText: "Modifier",
            bgColor: "indigo",
            textColor: "white",
            link: `/category/${id}/update`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="section">
          <div className="element">
            <div className="card">
              <CardHeader title="Informations générales" />
              <div className="w-full mt-3">
                <p className="label">Nom</p>
                <input className="input w-full" value={category?.name} disabled />
              </div>
              <div className="w-full mt-3">
                <p className="label">Nombre de clients</p>
                <input className="input w-full" value={category?.sitesCount} disabled />
              </div>
            </div>
          </div>

          <div className="element">
            <div className="card">
              <CardHeader title="Clients" />
              <CustomersList categoryId={+id!} limit={10} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
